import loginPrompt from './loginPrompt';
import abandonCheckout from './abandonCheckout/index';
import { tradePromosConfig } from './tradePromos/tradePromosConfig';
import { tradeGeneralOnboardingConfig } from './tradeGeneralOnboarding/tradeGeneralOnboardingConfig';
import { tradeDesignManagerOnboardingConfig } from './tradeDesignManagerOnboarding/tradeDesignManagerOnboardingConfig';
import { privacyPolicyChangeNoticeConfig } from './privacyPolicyChangeNotice/privacyPolicyChangeNoticeConfig';
import tradeRewardsLevelUp from './tradeRewardsLevelUp';
import { tradeVerifyFirmReminderConfig } from './tradeVerifyFirmReminder/tradeVerifyFirmReminderConfig';
import tradeWindfallReferral from './tradeWindfallReferral';
import loggedOutTrade from './loggedOutTrade';

export default [
    ...abandonCheckout,
    loginPrompt,
    privacyPolicyChangeNoticeConfig,
    tradeGeneralOnboardingConfig,
    tradeDesignManagerOnboardingConfig,
    ...tradePromosConfig,
    tradeRewardsLevelUp,
    tradeVerifyFirmReminderConfig,
    tradeWindfallReferral,
    loggedOutTrade,
];
